import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { CONTACT, NAV } from "../lib/content";
import { LOCATIONS } from "../lib/locations";
import { MaskText } from "./Motion";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-paper">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-7">
          <p className="text-sand text-[11px] uppercase tracking-[0.3em] mb-6">Let's begin</p>
          <MaskText
            as="h2"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[0.95]"
            lines={["Tell me about", "your day."]}
          />
          <Link
            to="/contact/"
            data-testid="footer-get-in-touch"
            className="inline-flex items-center gap-3 mt-10 border border-paper/30 rounded-full px-7 py-3.5 text-[11px] uppercase tracking-[0.22em] hover:bg-paper hover:text-ink transition-colors duration-500"
          >
            Get in Touch
          </Link>
        </div>

        <div className="md:col-span-2 md:col-start-9">
          <p className="text-paper/40 text-[10px] uppercase tracking-[0.25em] mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="link-underline text-sm text-paper/80 hover:text-paper">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-paper/40 text-[10px] uppercase tracking-[0.25em] mb-5">Studio</p>
          <ul className="space-y-3 text-sm text-paper/80">
            <li><a href={CONTACT.phoneHref} className="link-underline">{CONTACT.phone}</a></li>
            <li><a href={CONTACT.emailHref} className="link-underline break-all">{CONTACT.email}</a></li>
            <li className="pt-2 text-paper/50 leading-relaxed">{CONTACT.areas}</li>
            <li className="flex gap-4 pt-3">
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-paper/60 hover:text-paper transition-colors"><Instagram size={18} strokeWidth={1.4} /></a>
              <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-paper/60 hover:text-paper transition-colors"><Facebook size={18} strokeWidth={1.4} /></a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-10 border-t border-paper/10">
        <p className="text-paper/40 text-[10px] uppercase tracking-[0.25em] mb-5">Wedding photographer in</p>
        <div className="flex flex-wrap gap-x-6 gap-y-3">
          {LOCATIONS.map((l) => (
            <Link key={l.slug} to={`/${l.slug}-wedding-photographer/`} data-testid={`footer-area-${l.slug}`} className="text-sm text-paper/70 hover:text-paper link-underline">
              {l.area}
            </Link>
          ))}
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-paper/10 flex flex-col md:flex-row justify-between gap-4 text-[11px] tracking-wide text-paper/40">
        <p>© {new Date().getFullYear()} Jason Howard Photography — Chester &amp; Cheshire.</p>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/privacy/" data-testid="footer-privacy" className="link-underline hover:text-paper/80">Privacy Policy</Link>
          <Link to="/terms/" data-testid="footer-terms" className="link-underline hover:text-paper/80">Terms</Link>
          <span className="text-paper/30">Wedding &amp; portrait photography · North West England &amp; North Wales</span>
        </div>
      </div>
    </div>
  </footer>
);
